<template>
  <div class="d-flex flex-column head-links" ref="head_links_mobile" @click="onClick">
    <MobileHeadLink
      :links="links"
      :headerLinkTarget="headerLinkTarget"
    />
  </div>
</template>

<script>
import MobileHeadLink from './MobileHeadLink'
export default {
  components: {
    MobileHeadLink
  },
  name: 'MobileHeadLinks',
  props: {
    /**
     * link - String
     * name - String
     * links - links[]
     */
    links: Array,
    headerLinkTarget: String
  },
  methods: {
    findEl (target) {
      const overEl = target.dataset.headLink
      const links = this.$refs.head_links_mobile.querySelectorAll('[data-head-link]')
      const link = [].filter.call(links, el => el.dataset.headLink === overEl)[1]
      return link
    },
    onClick (event) {
      const target = event.target.closest('a')
      const link = this.findEl(target)
      const droplist = target.querySelector('.icon-droplist--mobile svg')
      if (!droplist) return

      const title = target.firstChild
      event.preventDefault()

      if (link.dataset.show && link.dataset.show === 'true') {
        title.style.opacity = 1
        link.dataset.show = false
        link.style.setProperty('display', 'none', 'important')
        droplist && (droplist.style.transform = 'none')
      } else {
        title.style.opacity = 0.5
        link.dataset.show = true
        link.style.setProperty('display', 'flex', 'important')
        droplist && (droplist.style.transform = 'rotate(-180deg)')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.head-links {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding-bottom: 24px;
  margin-bottom: 37.5px;
}
</style>
